import { connect } from 'react-redux';
import AppointmentManagement from './AppointmentManagement';

const mapStateToProps = state => ({
  viaSso: state.session.viaSso
});

const mapDispatchToProps = dispatch => ({

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppointmentManagement);



// WEBPACK FOOTER //
// ./src/containers/AppointmentManagement/index.js